import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9c438102")

_pushScopeId("data-v-9c438102")
const _hoisted_1 = {
  class: "batteryDetect",
  id: "batteryDetect"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "ui__checkTitle" }, "Electric System Inspection", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_batterySystemInfo = _resolveComponent("batterySystemInfo")
  const _component_batteryHealthy = _resolveComponent("batteryHealthy")
  const _component_checkItemBattery = _resolveComponent("checkItemBattery")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.isShowBatteryOtherMsg)
      ? (_openBlock(), _createBlock(_component_batterySystemInfo, {
          key: 0,
          renderData: _ctx.state.batterySystemInfoRenderData,
          checkStandardRouter: _ctx.state.checkStandardRouter
        }, null, 8, ["renderData", "checkStandardRouter"]))
      : _createCommentVNode("", true),
    (_ctx.isShowBatteryOtherMsg)
      ? (_openBlock(), _createBlock(_component_batteryHealthy, {
          key: 1,
          renderData: _ctx.state.contRenderData,
          checkStandardRouter: _ctx.state.checkStandardRouter
        }, null, 8, ["renderData", "checkStandardRouter"]))
      : _createCommentVNode("", true),
    _createVNode(_component_checkItemBattery, {
      renderData: _ctx.state.checkItemBattery
    }, null, 8, ["renderData"])
  ]))
})